import { LinearProgress } from '@mui/material';
import { useGlobalContext } from '../Context/GlobalContext';

const Loading = (
    {isDeterminate, progress}:
    {isDeterminate?: boolean, progress?: number}
) => {
    const { getThemeStyles } = useGlobalContext();
    const styles = getThemeStyles();
    return <div style={{ width: '100%' }}>
        <LinearProgress 
            variant={ isDeterminate ? 'determinate' : 'indeterminate' } 
            value={progress} 
            sx={{ 
                backgroundColor: styles['--theme-bg-color'], 
                '& .MuiLinearProgress-bar': { backgroundColor: styles['--theme-color'] } }}
            />
    </div>
}

export default Loading;